import { Component, Input, OnInit } from "@angular/core";
import { BaseComponent } from "src/app/base/base.component";
import { ActivatedRoute, Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {TranslateService} from '@ngx-translate/core';
import { IdeaService } from "src/app/service/idea.service";
import { IIdeaFiles } from "src/app/interfaces/idea";
import { environment } from "src/environments/environment";
import { take } from "rxjs/operators";

@Component({
  selector: "app-upload-file",
  templateUrl: "./upload-file.component.html",
  styleUrls: ["./upload-file.component.scss"],
})
export class UploadFileComponent extends BaseComponent implements OnInit {
  @Input()
  ideaId!: string

  url!: {id: string, code: string}

  inputFile: File;
  files: IIdeaFiles[] = [];

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public loading: NgxSpinnerService,
    public translate: TranslateService,
    private ideaService: IdeaService,
  ) {
    super(router, loading, translate);
  }

  ngOnInit(): void {
    this.geturlParams()
    this.getAllIdeaFiles()
  }

  geturlParams(): void {
    this.url = this.activatedRoute.snapshot.params as { id: string; code: string};
  }

  saveAttachment(event: Event): void {
    const target = event.target as HTMLInputElement;

    const sizeInMb = target.files[0]?.size / (1024 * 1024);

    if (sizeInMb > 10) return this.showMessage('Atenção','Arquivo excede o limite de 10 MB. Por favor, selecione um arquivo menor');
    if (this.files.length >= 5) return this.showMessage('Atenção', 'Máximo de arquivos atingido')

    this.inputFile = target.files[0];

    const formData = new FormData();
    formData.append("file", this.inputFile);

    this.inputFile && this.uploadAttachment(formData)
  }

  uploadAttachment(file: FormData): void {
    const id = this.url.id;
    const dir = 'idea-premiation-files';

    this.ideaService.uploadFile(id, dir, file)
    .pipe(take(1))
    .subscribe({
      next: (response) => {
        const file = {
          ...response,
          fileName: environment.bucketUrl + response.fileName
        }
        
        this.files.push(file)
        this.inputFile = null
        this.showMessage('Sucesso', 'Upload realizado com sucesso', 'success')
      },
      error: () => {
        this.showMessage('Atenção', 'Erro ao tentar fazer upload', 'error')
      },
    })
  }

  onRemoveFile(fileId: string): void {
    this.confirmMessage(`Atenção`, `Deseja remover o arquivo ?`, () => {
      this.ideaService.deleteFile({ id: fileId })
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.files = this.files.filter(file => file.id !== fileId)
          this.showMessage('Sucesso', 'Arquivo deletado com sucesso', 'success')
        },
        error: () => {
          this.showMessage('Atenção', 'Erro ao tentar deletar arquivo')
        },
      })
    });
  }

  getAllIdeaFiles(): void {
    this.ideaService.getAllIdeaFiles({id: this.url.id})
    .pipe(take(1))
    .subscribe({
      next: (response) => {
        this.files = response.getAllIdeaFiles.map((item) => {
          return {
            ...item,
            fileName: environment.bucketUrl + item.fileName
          }
        })
      },
      error: () => {},
    })
  }
}
